import React from 'react'

export const PrivacyPolicyContainer = () => {
    return <>Privacy policy</>
}
